import React from 'react';
import ChapterPage from "../ChapterPage";
import ContentPage from "../ContentPage";
import {getData} from "../../requests/CRUD";
import {TRAINING, TRAINING_CONTENT} from "../../consts/tables";
import isEqual from "lodash.isequal";

export default class extends React.Component {
    constructor(props) {
        super(props);

        // Pre-initialize for known routes to avoid blank flash
        const isBrokerage = props.params && props.params.slug === 'brokerage-continuum';
        this.state = {
            page: isBrokerage ? 'chapter' : '',
            // A chapter with neither sub-chapters nor lesson content: renders as a
            // lesson, but super admins also get an entry point to start sub-chapters
            // (otherwise the first sub-chapter could only ever be seeded in the DB).
            emptyChapter: false,
            startInEdit: false,
        };
    }

    componentDidMount() {
        this.fetch(this.props.params);
    }

    componentWillReceiveProps(nextProps) {
        if (!isEqual(this.props.params, nextProps.params))
            this.fetch(nextProps.params);
    }

    fetch(params) {
        const keys = Object.keys(params);
        const slugs = params && keys.length ? keys.map(key => params[key]) : [];
        const subchapterParentSlug = slugs.join('/');

        // Only a top-level brokerage chapter (a map circle: /brokerage-continuum/<chapter>)
        // is ambiguous when empty — it may become a section of sub-chapters or a lesson.
        // Anything nested deeper (post-close/happy-birthday, close/close, …) and other
        // courses' pages are authored as lessons: plain Edit → content editor.
        const cleanSlugs = slugs.filter(Boolean);
        const canStartSubchapters = cleanSlugs.length === 2 && cleanSlugs[0] === 'brokerage-continuum';

        getData({
            tableCode: TRAINING,
            options: {
                filter: [{
                    text: '',
                    code: 'DELETED',
                    type: 'null',
                }, {
                    text: subchapterParentSlug,
                    code: 'PARENT_SLUG',
                    type: 'exact',
                }],
                filterType: 'and',
            }
        }).then(res => {
            if (res && res.success) {
                if (res.data.length) {
                    if (this.state.page !== 'chapter')
                        this.setState({page: 'chapter', emptyChapter: false, startInEdit: false});
                    return;
                }
                if (!canStartSubchapters) {
                    this.setState({page: 'content', emptyChapter: false, startInEdit: false});
                    return;
                }
                // No sub-chapters — check whether lesson content exists so a truly
                // empty chapter can offer the "start sub-chapters" path.
                getData({
                    tableCode: TRAINING_CONTENT,
                    options: {
                        filter: [{
                            text: '',
                            code: 'DELETED',
                            type: 'null',
                        }, {
                            text: subchapterParentSlug,
                            code: 'CHAPTER_SLUG',
                            type: 'exact',
                        }],
                        filterType: 'and',
                    },
                }).then(contentRes => {
                    // A row may exist but hold no real content (e.g. an empty editor
                    // save stores NULL/empty HTML) — that still counts as empty.
                    const hasContent = Boolean(contentRes && contentRes.success
                        && Array.isArray(contentRes.data)
                        && contentRes.data.some(row => {
                            const html = row && row.CONTENT ? String(row.CONTENT) : '';
                            if (/<(img|table|iframe|video|object)\b/i.test(html)) return true;
                            return html.replace(/<[^>]*>/g, ' ').replace(/&nbsp;/gi, ' ').trim().length > 0;
                        }));
                    this.setState({page: 'content', emptyChapter: !hasContent, startInEdit: false});
                });
            }
        });
    }

    render() {
        const {page, emptyChapter, startInEdit} = this.state;
        if (page === 'chapter')
            return <ChapterPage {...this.props} startInEdit={startInEdit}/>;
        if (page === 'content')
            return (
                <ContentPage
                    {...this.props}
                    allowSubchapters={emptyChapter}
                    onStartSubchapters={() => this.setState({page: 'chapter', startInEdit: true})}
                />
            );

        // Only show blank if we truly don't know yet and it's the first render
        return (
            <div className='page-rounded-corner-container'>
                <div className='page-header-container training'/>
            </div>
        )
    }
}
